import React, { Component } from 'react';
import axios from 'axios';
import config from '../config'

class Register extends Component {
    constructor() {
        super();
        this.state = {
            invalid: true,
            rememberMe: false,
            email: '',
            password: '',
            isAuthenticated: false,
            token: '',
            refreshToken: '',
            firstname: '',
            lastname: '',            
            mobile: '',
            confirmPassword: '',
            confirmPasswordError: true,
            registered: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
      }
    handleInputChange(event){
        event.preventDefault();             
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
        //  check if password and confirmation match        
        if(name === 'confirmPassword'){
            if(value !== this.state.password){
                this.setState(
                    {
                        confirmPasswordError: true,
                    }
                );
                
            }
            else{
                this.setState(
                    {
                        confirmPasswordError: false,
                    }
                );
            }
        }
    }

    handleSubmit(event){        
        event.preventDefault();
        if (!event.target.checkValidity()) {
            this.setState({
            invalid: true,
            displayErrors: true,
          });
          return;
        }
        if (this.state.confirmPasswordError) {
            this.setState({
            invalid: true,
            displayErrors: true,
          });
          return;
        }
        this.setState({
          invalid: false,
          displayErrors: false,
        });

        let data = {};
        data.name = {};
        data.name.firstname = this.state.firstname;
        data.name.lastname = this.state.lastname;        
        data.email = this.state.email;
        data.mobile = this.state.mobile;
        data.password = this.state.password;

               // make API call here
        // make the uri dynamic
        // change to axios
        let _API_URI = config.API_BASE_URL + config.API_REGISTER;
        let _method = 'POST';
        let _headers = {
            "Content-Type": "application/json"
          }
        axios({
            url: _API_URI,
            method: _method,
            data: JSON.stringify(data),
            headers: _headers,
        })
        .then(response => {            
            if (response.status === 200) {
                //  handle success                
                if(this.state.rememberMe){
                    localStorage.token = data.token
                    localStorage.refreshToken = data.refreshToken        
                    localStorage.isAuthenticated = true
                }                
                this.setState({
                    token: data.token,
                    refreshToken: data.refreshToken,
                    isAuthenticated: true,
                    registered: true,
                });
            } else {
              throw new Error(response.statusText);
            }
          })
        .catch(error => {
            //  handle error
            this.setState({
                error: true,
                message: error.response.data.message,
                rememberMe: false,
                email: '',               
                token: '',
                refreshToken: '',
                isAuthenticated: false,
                
            });            
            localStorage.token = ''        
            localStorage.refreshToken = ''        
            localStorage.isAuthenticated = false            
        });
      }


    render() {
        const {firstname, lastname, email, mobile, password, confirmPassword, error, message, registered} = this.state;
        return (
            <div className="container">
                <div className="card card-register mx-auto mt-5">
                    <div className="login-header text-center mt-2">Register an Account</div>
                    <div className="card-body">
                    {(error && !registered) &&
                        <div className="alert alert-danger">
                            <strong>Error! </strong>{ message }
                        </div>
                    }
                    {registered && 
                    <div>
                        <div className="text-center mb-4">
                            <h4>Hurray, you are just a step away !!!</h4>
                            <p>Check your email, we will send you instructions on how to activate your account.</p>
                        </div>
                        <div className="text-center">
                            <a className="d-block small mt-3" href="/pnc/auth/">Login</a>                            
                        </div>
                    </div>
                    }
                    {!registered &&
                    <div> 
                    <form onSubmit={this.handleSubmit}>
                        <div className="">
                        <div className="form-row">
                            <div className="col-md-6 form-group">
                            <div className="">
                                <input  type="text" 
                                        id="firstname" 
                                        name="firstname" 
                                        className="form-control custom-input" 
                                        placeholder="First Name *" 
                                        required="required" 
                                        value={firstname}
                                        onChange={this.handleInputChange}
                                        maxLength="30"
                                        pattern="[A-Za-z]{3,30}"/>
                            </div>
                            </div>
                            <div className="col-md-6 form-group">
                            <div className="">
                                <input  type="text" 
                                        id="lastname" 
                                        name="lastname" 
                                        className="form-control custom-input" 
                                        placeholder="Last Name *" 
                                        required="required"
                                        value={lastname}
                                        onChange={this.handleInputChange}
                                        maxLength="30"
                                        pattern="[A-Za-z]{3,30}" />
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="form-group">
                        <div className="">
                            <input  type="email" 
                                    id="email" 
                                    name="email" 
                                    className="form-control custom-input" 
                                    placeholder="Email Address *" 
                                    required="required"
                                    value={email}
                                    onChange={this.handleInputChange} 
                                    maxLength="50"/>
                        </div>
                        </div>
                        <div className="form-group">
                        <div className="">
                            <input  type="text" 
                                    id="mobile"
                                    name="mobile"
                                    className="form-control custom-input" 
                                    placeholder="Mobile No. *"
                                    required="required"                                      
                                    value={mobile}
                                    onChange={this.handleInputChange}
                                    title="Please enter your mobile number."
                                    maxLength="10"
                                    pattern="[0-9]{10}" />
                        </div>
                        </div>
                        <div className="">
                            <div className="form-row">
                                <div className="col-md-6 form-group">
                                <div className="">
                                    <input  type="password" 
                                            id="password" 
                                            name="password" 
                                            className="form-control custom-input" 
                                            placeholder="Password *" 
                                            required="required"
                                            value={password}
                                            onChange={this.handleInputChange}
                                            minLength="8" 
                                            maxLength="20"
                                            pattern="^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$"/>
                                </div>
                                </div>
                                <div className="col-md-6 form-group">
                                <div className="">
                                    <input  type="password" 
                                            id="confirmPassword" 
                                            name="confirmPassword" 
                                            className="form-control custom-input" 
                                            placeholder="Confirm password *" 
                                            required="required"  
                                            value={confirmPassword}                                      
                                            onChange={this.handleInputChange}
                                            minLength="8" 
                                            maxLength="20"
                                            pattern="^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$"/>
                                </div>
                                </div>
                            </div>
                            <div className="registerMsg">HINT: Password must contain a capital alphabet, a number, a special character and minimum 8 characters. </div>
                        </div>
                        <div className="form-group">
                            <div className="text-center">
                                
                                    <button className="btn btn-primary mr-3" type="submit">Register</button> 
                               
                                <a className="btn btn-danger" href="{this.props.history.goBack}" onClick={this.props.history.goBack}>Cancel</a>
                               
                            </div>
                        </div>

                        {}
                
                    </form>
                    <div className="text-center">
                        <a className="small mt-3" href="/pnc/auth/">Already have an account?</a>
                    </div>
                    <div className="text-center">    
                        <a className="small" href="/pnc/auth/forgotpassword">Forgot Password?</a>
                    </div>
                    </div>
                    }                    
                    </div>
                    <div className="login-footer"> © 2024 Reliance Industries Limited. All rights reserved.</div>
                </div>
                </div>
        );
    }
}

export default Register;


// WEBPACK FOOTER //
// ./src/components/Register.js